import { FC } from "react";

import { useFullUserProfileContext } from "Bands/contexts";
import { Loader, PlaceTeaser, Title } from "shared/components";
import { Spacer } from "shared/layout";
import { GridContainer } from "shared/styles";
import { copy } from "shared/assets";
import { useFetchingContactDetails } from "Bands/utils";

const addressCopy = copy.userAddress;

export const Addresses: FC = () => {
  const { addresses } = useFullUserProfileContext();
  const { fetchingAddresses } = useFetchingContactDetails();

  if (fetchingAddresses) return <Loader />;
  if (!addresses?.length) return null;

  return (
    <Spacer size="s">
      <Title title={addressCopy.title} asComponent="h3" size="s" />
      {!!addresses?.length && (
        <GridContainer>
          {addresses?.map((address) => (
            <PlaceTeaser key={address.id} {...address} />
          ))}
        </GridContainer>
      )}
    </Spacer>
  );
};
